import withAlert from './WithAlert';

export default withAlert;
